import * as React from 'react';
import { connect } from 'react-redux';

import { ModalFrame, ModalFrameInner } from 'components/modal';
import InfoNote from 'components/info-note/InfoNote';
import VerticalSpacing from 'components/vertical-spacing/VerticalSpacing';

import CampaignEdit from 'modules/campaigns/components/CampaignEdit';

import { closeNotification } from 'redux-store/reducers/common-reducer';

import { trackEventEditCampaign } from 'modules/tracking/utils/tracking';

import { t } from 'utils/language';

import type { CampaignOverview, PromiseAction } from 'types';

type StateProps = {
  orgId: number
};

type OwnProps = {
  brandProfileId: number,
  campaignId: number,
  campaignOverview: CampaignOverview,
  triggerType: string,
  onCloseModal: () => PromiseAction
};

type DispatchProps = {
  dispatchCloseNotification: () => void
};

type Props = StateProps & OwnProps & DispatchProps;

const CampaignEditModal = (
  {
    campaignId,
    campaignOverview,
    orgId,
    brandProfileId,
    triggerType,
    onCloseModal,
    dispatchCloseNotification
  }: Props
): JSX.Element => {
  React.useEffect(() => {
    dispatchCloseNotification();
    trackEventEditCampaign(triggerType);
  }, [orgId, brandProfileId, campaignId, triggerType]);

  return (
    <ModalFrame
      title={t('campaign_edit')}
    >
      <ModalFrameInner>
        <InfoNote>{t('campaign_modal_info_note')}</InfoNote>
        <VerticalSpacing type="medium" />
        <CampaignEdit
          campaignId={campaignId}
          campaignOverview={campaignOverview}
          askToSendNotifications
          onCancel={onCloseModal}
          onSubmit={onCloseModal}
        />
      </ModalFrameInner>
    </ModalFrame>
  );
};

const mapStateToProps = ({ organizations }): StateProps => ({
  orgId: organizations.currentOrganizationId
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchCloseNotification: () => (
    dispatch(closeNotification())
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(CampaignEditModal);
